

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _contingencies = require('./contingencies');

var _contingencies2 = _interopRequireDefault(_contingencies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// FI error fields and xo frontend models map
var FIELD_TO_MODEL_MAPPING = {
    ACTOR: [],
    BILLING_ADDRESS: ['cardmodel.address'],
    BIN: ['card.type', 'card.number'],
    CARD: ['card.type', 'card.number'],
    CUP_CARD: ['card.type', 'card.number'],
    CVV: ['card.security_code'],
    DOB: ['dob.value', 'user.dob_day', 'user.dob_month', 'user.dob_year'],
    EXPIRY: ['expiryDate', 'card.expiry_month', 'card.expiry_year']
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$fiErrorUtil', function () {
    return {
        addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {
            // error handling for filifecycle and fimanagement.
            if (!errorData.errorCodes) {
                errorData.errorCodes = errorData && [errorData['0']];
            }

            var messages = [];

            if (errorData.errorCodes && errorData.errorCodes.length) {
                errorData.errorCodes.forEach(function (errorCode) {
                    var contentKey = _contingencies2['default'][errorCode] || defaultKey || 'errorGeneral';
                    var message = void 0;

                    if (angular.isArray(contentKey)) {
                        for (var i = 0; i < contentKey.length; i++) {
                            message = (0, _squid.$renderContent)(contentBundle + '.' + contentKey[i], prop);
                            if (message) {
                                break;
                            }
                        }
                    } else {
                        message = (0, _squid.$renderContent)(contentBundle + '.' + contentKey, prop);
                    }
                    messages.push(message);
                });
            } else {
                messages.push((0, _squid.$renderContent)(contentBundle + '.' + 'errorGeneral', prop));
            }

            return {
                msgs: messages,
                type: 'error'
            };
        },

        highlightInvalidFields: function highlightInvalidFields(invalidFields, $element) {
            for (var _iterator = invalidFields, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var model = _ref;

                var $field = $($element).find('[ng-model="' + model + '"]');

                $field.addClass('backendError');
                $field.attr('aria-invalid', true);
            }

            $($element).find('.backendError').first().focus();
        },

        mapValidationErrorToModel: function mapValidationErrorToModel() {
            var invalidFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var errorProperty = 'VALIDATION_ERROR_';

            // if there is only one invalid field then fetch the corresponding error message else return the
            // generic validation error message
            if (invalidFields.length === 1) {
                return {
                    invalidModels: FIELD_TO_MODEL_MAPPING[invalidFields[0]],
                    errorProperty: errorProperty + invalidFields[0]
                };
            }
            return {
                invalidModels: [],
                errorProperty: errorProperty + 'GENERIC'
            };
        },

        addPageErrorByErrorName: function addPageErrorByErrorName(contentBundle, prop) {
            var defaultKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'INTERNAL_ERROR';

            var message = (0, _squid.$renderContent)(contentBundle + '.' + prop);

            if (!message || !message.toString()) {
                // log content not found
                _logger.$logger.error('fi_content_missing', {
                    prop: prop
                });
                message = (0, _squid.$renderContent)(contentBundle + '.' + defaultKey);
            }

            return {
                msgs: [message],
                type: 'error'
            };
        },

        /**
         * Highlight the Error Fields by ng-model
         * @param errorData
         * @param element
         * @param modelPrefix
         */
        addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {
            if (errorData.fields && errorData.fields.length) {
                errorData.fields.forEach(function (field) {
                    var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                });
            }
            $(element).find('.backendError:first').focus();
        },

        /**
         * Highlight the Error Fields by element name
         * @param errorData
         * @param element
         * @param modelPrefix
         */
        addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {
            if (errorData.fields && errorData.fields.length) {
                errorData.fields.forEach(function (field) {
                    var fieldName = void 0;

                    if (modelPrefix && field.field && field.field.length > 0) {
                        // Add prefix with CamelCase of field name
                        fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
                    } else {
                        fieldName = field.field;
                    }
                    var $field = $(element).find('[name="' + fieldName + '"]');

                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                });
            }
            $(element).find('.backendError:first').focus();
        }
    };
});

_squid.$renderContent;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/fi-contingency-list/util.js
// module id = ../node_modules/xo-wallet-components/src/fi-contingency-list/util.js
// module chunks = 0